import { CommonStoreGetters } from '@/utils/storeHelpers'
import type { ISearchGetters, ISearchState } from '../types.ts'

/**
 * Safely get resultData object for a given searchType.
 */
function getResultData(state: ISearchState, searchType: string): Record<string, any> | null {
  const key = `${searchType}.resultData` as keyof ISearchState
  const resultData = state[key]
  if (resultData && typeof resultData === 'object' && Object.keys(resultData).length > 0) {
    return resultData as Record<string, any>
  }
  return null
}

const getters: ISearchGetters = {
  ...CommonStoreGetters,

  isResultLoaded: (state: ISearchState) => (searchType: string): boolean => {
    return !!getResultData(state, searchType)
  },

  getResultsRecordTotal: (state: ISearchState) => (searchType: string): number => {
    const data = getResultData(state, searchType)
    const total = Number(data?.total ?? data?.hits)
    if (Number.isFinite(total)) {
      return total
    }
    const records = data?.records
    return Array.isArray(records) ? records.length : 0
  },

  getResultSummaryText: (state: ISearchState) => (searchType: string): string => {
    const data = getResultData(state, searchType)
    return data?.summary || ''
  },

  getResultActionOptions: (state: ISearchState) => (searchType: string): { id: string; text: string }[] => {
    const data = getResultData(state, searchType)
    return (data?.actions || []).map((action: any) => ({
      id: action.key as string,
      text: action.val as string
    }))
  }
}

export default getters
